import { render, staticRenderFns } from "./PhotoUploader.vue?vue&type=template&id=272853a6&lang=pug&"
import script from "./PhotoUploader.vue?vue&type=script&lang=js&"
export * from "./PhotoUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports